import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const Rain = (props: any) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M18.26 14.74A10.61 10.61 0 0017 10.9c-.73-1.4-1.58-2.71-2.42-4-.66-1.05-1.32-2.1-1.88-3.22A4.94 4.94 0 0112.07 2c0 .13-.08.27-.13.4a14.58 14.58 0 01-1.34 2.82C9.73 6.65 8.86 8.05 8 9.46a17.62 17.62 0 00-1.8 3.64 7.48 7.48 0 00-.32 3.81 6.29 6.29 0 002.55 4A5.93 5.93 0 0011.87 22a6 6 0 003.89-1.21 6.25 6.25 0 002.5-6.05zm-7 5.51s-1.75 1-3.75-2.25a5.81 5.81 0 010-5.5s1.25-2.25 1 .5a5.5 5.5 0 001.25 4s2.77 2.25 1.52 3.25z" />
    </SvgIcon>
  );
};

export default Rain;
